import { render, staticRenderFns } from "./AMSqaRegRootComponent.vue?vue&type=template&id=56d22b36&scoped=true"
import script from "./AMSqaRegRootComponent.vue?vue&type=script&lang=js"
export * from "./AMSqaRegRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d22b36",
  null
  
)

export default component.exports